module.exports = __webpack_public_path__ + "img/1.837fd152.jpg";